var exports = {
  "A": "TargetsPanelText__EbYGFZ",
};

module.exports = exports;
